import { LoginView } from "src/sections/login";

export default function LoginPage() {
    return (
        <LoginView />
    );
}